import { Select } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { Maybe } from "@oysterhr/schema"
import classNames from "classnames"
import { KeywordScoreBadge } from "./KeywordScoreBadge"
import { JobRoleSelectOption } from "./JobRoleSelect"

export const JobRoleOptions = ({
  options = [],
  loading = false,
}: {
  options: Maybe<JobRoleSelectOption[]> | undefined
  loading?: boolean
}) => {
  const { t } = useTranslation("salary_insights_tool/JobRoleSelect")
  const noTitleMatches = !options?.some(option => option.keywordScore == null)

  const EmptyText = ({ children }: { children: string }) => (
    <div
      className={classNames({
        "cursor-not-allowed opacity-20": loading,
      })}
    >
      <Select.EmptyState>{children}</Select.EmptyState>
    </div>
  )

  return (
    <>
      {!options?.length && <EmptyText>{t("emptyOptionsMatch")}</EmptyText>}
      {noTitleMatches && Boolean(options?.length) && <EmptyText>{t("emptyTitleMatch")}</EmptyText>}
      {options?.map(option => (
        <Select.Option
          disabled={loading}
          key={option.value}
          value={option.value}
          className="overflow-hidden text-ellipsis"
          endAdornment={<KeywordScoreBadge keywordScore={option.keywordScore} />}
        >
          <span title={option.label.length > 15 ? option.label : ""}>{option.label}</span>
        </Select.Option>
      ))}
    </>
  )
}
JobRoleOptions.displayName = "Select.Option"
